import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})

export class PerformCalculationsService {

  constructor() { }

  public previousYearData(userOptions, budgetData) {
    let yearIndex;
    let currYear;
    userOptions.years.forEach((element, index) => { element.active ? yearIndex = index : yearIndex = yearIndex; });
    yearIndex > 0 ? (yearIndex -= 1, currYear = userOptions.years[yearIndex].yearName) : yearIndex = -1;  // Same as doing YI = YI-1, however this should be safer for values < 0
    const actual = userOptions.months.map(b => b = 0);
    if (yearIndex > -1) {
      const newOptions = JSON.parse(JSON.stringify(userOptions));
      newOptions.years.forEach((element, index) => { newOptions.years[index].active = false; });
      newOptions.years[yearIndex].active = true;
      budgetData.forEach(element => {
        if (this.isYearActive(newOptions, element.year)) {
          if (this.isMonthActive(newOptions, element.month)) {
            if (this.isParkActive(newOptions, element.parkName)) {
              userOptions.power.active ? actual[element.month - 1] += element.actual :
                userOptions.currency.active ? actual[element.month - 1] += element.cActual : null;
            }
          }
        }
      });
    }
    return (actual);
  }

  // All countries, (That means All parks, even if not selected)
  public performPieCalculations(userOptions, budgetData, parkData) {
    const indexes = userOptions.countries.map(b => b.countryName);
    const actual = userOptions.countries.map(b => 0);
    budgetData.forEach(element => {
      if (this.isMonthActive(userOptions, element.month)) {
        if (this.isYearActive(userOptions, element.year)) {
          const country = this.findCountry(element.parkName, parkData);
          const index = indexes.findIndex(a => a === country);
          userOptions.power.active ? actual[index] += element.actual :
            userOptions.currency.active ? actual[index] += element.cActual : null;
        }
      }

    });
    return ({ indexes, actual });
  }

  public performHorizCalculations(userOptions, budgetData) {
    const indexes = [];
    userOptions.parks.forEach((element) => {
      if (this.isParkActive(userOptions, element.parkName)) {
        indexes.push(element.parkName);
      }
    });
    const cActual = indexes.map(b => 0);
    const cBudget = indexes.map(b => 0);
    const cPercent = indexes.map(b => 0);
    const mActual = indexes.map(b => 0);
    const mBudget = indexes.map(b => 0);
    const mPercent = indexes.map(b => 0);
    budgetData.forEach(element => {
      if (this.isYearActive(userOptions, element.year)) {
        if (this.isMonthActive(userOptions, element.month) && (element.actual !== 0)) {
          const index = indexes.findIndex(park => park === element.parkName);
          // -c- prefix is for cumulative (first case) and currency (element.c....)
          userOptions.power.active ? (cActual[index] += element.actual, cBudget[index] += element.budget) :
            userOptions.currency.active ? (cActual[index] += element.cActual, cBudget[index] += element.cBudget) : null;
          if (element.month === (this.lastActiveMonth(userOptions) + 1)) {
            // -m- prefix is for "month"
            userOptions.power.active ? (mActual[index] += element.actual, mBudget[index] += element.budget) :
              userOptions.currency.active ? (mActual[index] += element.cActual, mBudget[index] += element.cBudget) : null;
          }
        }
      }
    });
    cPercent.forEach((element, index) => {
      cBudget[index] !== 0 ? cPercent[index] = 100 * (cActual[index] - cBudget[index]) / cBudget[index] : 0;
      mBudget[index] !== 0 ? mPercent[index] = 100 * (mActual[index] - mBudget[index]) / mBudget[index] : 0;
    });
    let output = indexes.map((x, i) => [x, cPercent[i], mPercent[i]]);
    output = output.sort((a, b) => (parseFloat(b[1]) - parseFloat(a[1])));
    return output;
  }

  public performCalculations(userOptions, budgetData) {
    const actual = [];
    const budget = [];
    const theoretical = [];
    const indexes = [];
    let output;
    for (let i = 0; i < userOptions.months.length; i++) {
      indexes.push(userOptions.months[i].monthName);
      budget.push(0);
      theoretical.push(0);
      if (userOptions.months[i].active) {
        actual.push(0);
      }
    }
    budgetData.forEach(element => {
      if (this.isParkActive(userOptions, element.parkName)) {
        if (this.isYearActive(userOptions, element.year)) {
          userOptions.power.active ? budget[indexes.indexOf(this.mName(element.month))] += element.budget :
            userOptions.currency.active ? budget[indexes.indexOf(this.mName(element.month))] += element.cBudget :
              null;
          if (this.isMonthActive(userOptions, element.month)) {
            userOptions.power.active ? (
              actual[indexes.indexOf(this.mName(element.month))] += element.actual,
              theoretical[indexes.indexOf(this.mName(element.month))] += element.theoretical) :
              userOptions.currency.active ? (
                actual[indexes.indexOf(this.mName(element.month))] += element.cActual,
                theoretical[indexes.indexOf(this.mName(element.month))] += element.cTheoretical) :
                null;
          }
        }

      }
    });
    // Return theoretical data only if there is theoretical
    (theoretical) ?
      output = { indexes, actual, budget, theoretical } :
      output = { indexes, actual, budget };
    return output;
  }

  public mName(name) {
    const months =  moment.monthsShort();
    return months[name - 1];
  }

  public isMonthActive(userOptions, monthNumber): boolean {
    let active = false;
    userOptions.months.forEach(element => {
      if ((element.monthNumber) === monthNumber) { active = (active || element.active); }
    });
    return active;
  }

  public isYearActive(userOptions, yearName): boolean {
    let active = false;
    userOptions.years.forEach(element => {
      if (element.yearName === yearName) { active = (active || element.active); }
    });
    return active;
  }

  public isParkActive(userOptions, parkName): boolean {
    let active = false;
    userOptions.parks.forEach(element => {
      if (element.parkName === parkName) { active = active || element.active; }
    });
    return active;
  }

 public findCountries(cpArray) {
  const clist = cpArray.map(a => a[1]);
  const newArray = [];
  clist.forEach(element => { newArray.includes(element) ? null : newArray.push(element); });
  return newArray;
}

  public findCountry(parkName, parkData) {
    const plist = parkData.map(b => b[0]);
    const index = plist.findIndex(park => park === parkName);
    return (parkData[index][1]);
  }

  public lastActiveMonth(userOptions) {
    let output = -1;
    userOptions.months.forEach((element, index) => { if (element.active) { output = index; } });
    return (output);
  }

  public isMillions(cpArray) {
    let isM = false;
    if (cpArray) {
      cpArray.forEach((element) => { if ((element / 1000000) > 1) { isM = true; } });
    }
    return isM;
  }

  public isThousands(cpArray) {
    let isT = false;
    if (cpArray) {
      cpArray.forEach((element) => { if ((element / 1000) > 1) { isT = true; } });
    }
    return isT;
  }

  // Order Of Magnitude (Returns 6 (Millions), 3 (Thousands) or 1 (Units))
  public getFinalOrder(cpArray): number {
    let oom = 0;
    this.isMillions(cpArray) ? oom = 6 :
      this.isThousands(cpArray) ? oom = 3 :
        oom = 0;  // (10^0 = 1)
    return oom;
  }

  public getPreferedOrder(o1, o2): number {
    let p = o2;
    o1 > o2 ? p = o1 : p = o2;
    return (p);
  }

  // Final units depending on units, Order of magnitude!
  public getFinalUnits(oom, units): string {
    let nUnits = 'unknown';
    units === '€' ? (
      oom === 6 ? nUnits = 'Million €' :
        oom === 3 ? nUnits = 'Thousand €' :
         nUnits = '€') :
      units === 'kWh' ? (
        oom === 6 ? nUnits = 'GWh' :
          oom === 3 ? nUnits = 'MWh' :
           nUnits = 'kWh'
      ) :
        nUnits = 'null';
    return nUnits;
  }

  public applyOrder(cpArray, order) {
    const div = Math.pow(10, order);
    const newArray = cpArray.map(b => b = b / div);
    return newArray;
  }


}


